// adapted from: https://maksymkotov.com/blog/call-a-function-after-an-element-has-been-created/
const runAfterElementExists = (jquery_selector, callback) => {
	const checker = window.setInterval(function () {
		//if one or more elements have been yielded by jquery
		//using this selector
		if (jQuery(jquery_selector).length) {
			//stop checking for the existence of this element
			clearInterval(checker);

			//call the passed in function via the parameter above
			callback();
		}
	}, 200); //I usually check 5 times per second
}

runAfterElementExists('.counter', () => {
	const counters = jQuery('.counter');

	Array.from(counters).forEach(counter => {
		const startTicker = () => {
			if (isVisible()) {
				runTicker();
			}
		}

		const runTicker = () => {
			// first let's remove our listener, as it won't be running again
			jQuery(window).off('scroll resize', startTicker);

			let start = 1000;
			const target = counter.dataset.counter;
			let duration = 3500; //ms

			// if our target number is lower than our counter start number (along with a bit of a
			// cushion offset), let's go ahead and start at a lower number.
			if ( target <  (start * 1.5) ) {
				start = 0;
			}
			// additionally, for real low numbers, speed up the time, so they aren't, like, crawling
			if ( target < 10 ) {
				duration = (duration / 3);
			}

			updateCounter(start);

			// adapted from https://codepen.io/chriscoyier/pen/xxVBqEg?editors=0011
			let startTimestamp = null
			const step = (timestamp) => {
				if (!startTimestamp) startTimestamp = timestamp
				const progress = Math.min((timestamp - startTimestamp) / duration, 1)
				updateCounter(Math.floor(progress * (target - start) + start))
				if (progress < 1) {
					window.requestAnimationFrame(step);
				}
			};
			window.requestAnimationFrame(step);
		}

		// Renders the count into the ticker on the page
		const updateCounter = count => {
			counter.innerText = formatCount(count);
			// html(formatCount(count))
		}

		const isVisible = () => {
			const counterTop = counter.offsetTop;
			const counterBottom = counterTop + jQuery(counter).outerHeight()
			const viewTop = jQuery(window).scrollTop()
			const viewBottom = viewTop + jQuery(window).height()

			return counterBottom > viewTop && counterTop < viewBottom
		}

		// add commas to our counter number with regex
		// see: https://blog.abelotech.com/posts/number-currency-formatting-javascript/
		const formatCount = count => {
			return count.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
		}

		// checks on scroll and resize: our only chances to move the element into view
		jQuery(window).on('scroll resize', startTicker);

		// run both of these functions on load, in case the page refreshes scrolled to the element already
		updateCounter(counter.dataset.counter)
		startTicker()
	})
})
